import { render, staticRenderFns } from "./company_new.vue?vue&type=template&id=e953a510&scoped=true"
import script from "./company_new.vue?vue&type=script&lang=js"
export * from "./company_new.vue?vue&type=script&lang=js"
import style0 from "./company_new.vue?vue&type=style&index=0&id=e953a510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e953a510",
  null
  
)

export default component.exports